import { shareAxios } from './config'

/**
 * 获取系统配置（侧边栏和车队名称）
 * @returns {Promise}
 */
export const getConfig = () => {
  return shareAxios.get('/frontend-api/getConfig')
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export const getUserInfo = () => {
  return shareAxios.get('/frontend-api/getme')
}

/**
 * 获取GPT车队列表
 * @returns {Promise}
 */
export const getCarList = () => {
  return shareAxios.post('/frontend-api/carpage')
}

/**
 * 获取Grok车队列表
 * @returns {Promise}
 */
export const getGrokCarList = () => {
  return shareAxios.post('/frontend-api/grokCarpage')
}

/**
 * 获取Gemini车队列表
 * @returns {Promise}
 */
export const getGeminiCarList = () => {
  return shareAxios.post('/frontend-api/geminiCarpage')
}

/**
 * 兑换码兑换
 * @param {string} redemptionCode - 兑换码
 * @returns {Promise}
 */
export const exchange = (redemptionCode) => {
  return shareAxios.post('/frontend-api/exchange', { redemptionCode })
}

/**
 * 获取用户订阅套餐列表
 * @returns {Promise}
 */
export const getUserSubscriptions = () => {
  return shareAxios.post('/frontend-api/getUserSubscriptions')
}

/**
 * 获取兑换记录列表
 * @returns {Promise}
 */
export const getRedemptionList = () => {
  return shareAxios.post('/frontend-api/getRedemptionList')
}

/**
 * 修改密码
 * @param {object} data - 修改密码数据
 * @returns {Promise}
 */
export const changePassword = (data) => {
  return shareAxios.post('/frontend-api/changePassword', data)
}

/**
 * 退出登录
 * @returns {Promise}
 */
export const logout = () => {
  return shareAxios.get('/frontend-api/logout')
}

